import React, { useEffect, useState } from "react";
import '../css/customModalDeleteWallet.css'
import Modal from 'react-bootstrap/Modal';
import CustomButton from "./CustomButton";
import { IoMdClose } from "react-icons/io";

const CustomModalNegBalDeleteWallet = (props) => {
    const {
        title = '',
    } = props;
    
    const handleClose  = () => {
        props.onHide();
    };


    return (
        <>
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modalMainContainerModalDeleteWallet"
        >
            <div className='mainOptionsColumnViewContainerModalDeleteWallet'>
                <div className='txtFirstOptionsTitleViewRowModalDeleteWallet'>
                    <div className='txtFirstCloseTitleModalDeleteWallet'>Sair</div>
                    <button className='btnViewFirstCloseTitleModalDeleteWallet' onClick={handleClose}><IoMdClose className="closeIconModalDeleteWallet"/></button>
                </div>
                <div className='txtFirstOptionsTitleViewModalDeleteWallet'>
                    <div className='txtViewContentContainerModalDeleteWallet'>
                        <div className='txtFirstOptionsTitleModalDeleteWallet'>Aviso!</div>
                    </div>
                    <div className='txtViewContentContainerModalDeleteWallet'>
                        <div className='txtContentModalDeleteWallet'>
                            Não será possivel apagar a sua carteira virtual Médis, por ter saldo negativo. Por favor regularize a sua situação.                        </div>
                        </div>
                    <div className='btnMainViewContainerModalDeleteWallet'>
                        <CustomButton 
                            text={'Compreendi'} 
                            onPress={handleClose}
                            textColor={'#00214D'}
                            color={'#15D4B6'}
                            hasArrow
                            iconColor={'#00214D'}
                        />
                    </div>
                </div>
            </div>
        </Modal>       
       </> 
    );
};

export default CustomModalNegBalDeleteWallet;